// extracted by mini-css-extract-plugin
export default {"settingTitle":"TopAssignees-module_settingTitle_d7bc435b","fullScreenChart":"TopAssignees-module_fullScreenChart_c6b588ed"};